var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "knowledge-base-tab" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c("div", { staticClass: "knowledge-base-section" }, [
          _c(
            "div",
            { staticClass: "section-header" },
            [
              _c("h4", [_vm._v("Bağlı Bilgi Tabanları")]),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.create"] } },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        primary: "",
                        disabled: !_vm.agent.llm,
                        icon: "add",
                      },
                      on: { click: _vm.showAddKnowledgeBase },
                    },
                    [
                      _vm._v(
                        "\n                        Bilgi Tabanı Ekle\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading &&
          _vm.agent.llm &&
          _vm.agent.llm.knowledge_base_ids &&
          _vm.agent.llm.knowledge_base_ids.length > 0
            ? _c(
                "div",
                { staticClass: "knowledge-base-list" },
                [
                  _c("a-table", {
                    attrs: {
                      columns: _vm.columns,
                      "data-source": _vm.linkedKnowledgeBases,
                      pagination: false,
                      loading: _vm.tableLoading,
                      rowKey: "knowledge_base_id",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c(
                                "PermissionController",
                                {
                                  attrs: {
                                    permissions: ["voice-agent.delete"],
                                  },
                                },
                                [
                                  _c("SupsisButton", {
                                    attrs: {
                                      danger: "",
                                      icon: "delete",
                                      small: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeKnowledgeBase(
                                          record.knowledge_base_id
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4007284452
                    ),
                  }),
                ],
                1
              )
            : !_vm.loading &&
              (!_vm.agent.llm ||
                !_vm.agent.llm.knowledge_base_ids ||
                _vm.agent.llm.knowledge_base_ids.length === 0)
            ? _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c(
                    "a-empty",
                    {
                      attrs: {
                        description:
                          "Bu ajana bağlı bilgi tabanı bulunmamaktadır",
                      },
                    },
                    [
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.create"] } },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "", disabled: !_vm.agent.llm },
                              on: { click: _vm.showAddKnowledgeBase },
                            },
                            [
                              _vm._v(
                                "\n                            Bilgi Tabanı Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Bilgi Tabanı Ekle", footer: null },
          on: { cancel: _vm.closeModal },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c(
            "a-spin",
            {
              staticClass: "kb-modal-content",
              attrs: { spinning: _vm.modalLoading },
            },
            [
              _c("p", [
                _vm._v("Ajana eklemek istediğiniz bilgi tabanını seçin:"),
              ]),
              _vm._v(" "),
              _vm.availableKnowledgeBases.length > 0
                ? _c(
                    "div",
                    { staticClass: "available-kbs-list" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.selectedKnowledgeBaseId,
                            callback: function ($$v) {
                              _vm.selectedKnowledgeBaseId = $$v
                            },
                            expression: "selectedKnowledgeBaseId",
                          },
                        },
                        [
                          _c("a-list", {
                            staticClass: "knowledge-base-select-list w-100",
                            attrs: {
                              "data-source": _vm.availableKnowledgeBases,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "renderItem",
                                  fn: function (item) {
                                    return _c(
                                      "a-list-item",
                                      { staticClass: "kb-list-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "kb-radio-wrapper" },
                                          [
                                            _c("a-radio", {
                                              attrs: {
                                                value: item.knowledge_base_id,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "kb-item" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kb-name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.knowledge_base_name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "kb-info" },
                                                  [
                                                    _c("a-tag", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.knowledge_base_sources
                                                            ? item
                                                                .knowledge_base_sources
                                                                .length
                                                            : 0
                                                        ) +
                                                          "\n                                            kaynak\n                                        "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-tag",
                                                      {
                                                        attrs: {
                                                          color:
                                                            _vm.getStatusColor(
                                                              item.status
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getStatusText(
                                                              item.status
                                                            )
                                                          ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              3695215340
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "no-available-kbs" },
                    [
                      _c(
                        "a-empty",
                        {
                          attrs: {
                            description:
                              "Eklenebilecek bilgi tabanı bulunamadı",
                          },
                        },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: { click: _vm.navigateToKnowledgeBase },
                            },
                            [_vm._v(" Bilgi Tabanı Oluştur")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c("SupsisButton", { on: { click: _vm.closeModal } }, [
                    _vm._v("İptal"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      class: { "opacity-50": _vm.submitLoading },
                      attrs: {
                        primary: "",
                        disabled:
                          !_vm.selectedKnowledgeBaseId || _vm.modalLoading,
                      },
                      on: { click: _vm.addKnowledgeBase },
                    },
                    [
                      _vm.submitLoading
                        ? _c("i", { staticClass: "material-icons spin" }, [
                            _vm._v("autorenew"),
                          ])
                        : _vm._e(),
                      _vm._v("\n                    Ekle\n                "),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-header" }, [
      _c("h3", [_vm._v("Bilgi Tabanı")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Ajanınızın kullanacağı bilgi tabanlarını burada yapılandırabilirsiniz. Bilgi tabanları, ajanınızın\n            cevaplarını desteklemek için kullanılır.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }